module.exports = __webpack_public_path__ + "img/improve_section_right_top_2.8f519be9.png";